import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  inject,
  NgModule,
  provideAppInitializer
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  GlobalErrorHandler,
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
  OneEducationCoreModule,
  ServerErrorInterceptor
} from '@oneeducation/app-core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalRedirectComponent
} from '@azure/msal-angular';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { CardModule } from 'primeng/card';
import { appInitializerFactory } from './app.initializerfactory';
import { UserManagementModule } from '@usermanagement/user-management.module';
import { SchoolManagementModule } from '@schoolmanagement/school-management.module';
import { SupportDocumentManagementModule } from '@supportdocumentmanagement/support-document-management.module';
import { SharedModule } from '@shared/shared.module';
import { ExclusionModule } from '@exclusionmodule/exclusion.module';
import { ConfigLoaderService } from './app-config-loader.service';
import { LoaderService } from '@shared/services';
import { LoaderInterceptorService } from '@shared/interceptors/loader-interceptor.service';
import { providePrimeNG } from 'primeng/config';
import Nora from '@primeuix/themes/nora';
import { definePreset } from '@primeuix/themes';
const MyTheme = definePreset(Nora);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    MsalModule,
    CardModule,
    OneEducationCoreModule,
    UserManagementModule,
    SchoolManagementModule,
    SupportDocumentManagementModule,
    SharedModule,
    ExclusionModule
  ],
  providers: [
    ConfigLoaderService,
    providePrimeNG({
      theme: {
        preset: MyTheme,
        options: {
          darkModeSelector: false, // Disable dark mode detection
          cssLayer: false
        }
      }
    }),
    provideAppInitializer(() => {
      const initializerFn = appInitializerFactory(inject(ConfigLoaderService));
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    LoaderService,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
